<template>
  <div>
    <el-form-item
      label="列表关联业务模型"
      :prop="null === index ? businessModelListField : 'tabs.' + index + '.' + businessModelListField"
      :rules="[{ required: true, validator: check, message: '请选择业务模型', trigger: 'change' }]"
    >
      <el-select v-model="standardForm[businessModelListField]" style="width: 100%" clearable filterable multiple>
        <el-option v-for="(item, id) in majorList" :key="id" :value="item.tableName" :label="item.businessName"> </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="列表主业务模型"
      :prop="null === index ? tableNameField : 'tabs.' + index + '.' + tableNameField"
      :rules="[{ required: true, message: '请选择主业务模型', trigger: 'change' }]"
    >
      <el-select v-model="standardForm[tableNameField]" style="width: 100%" clearable filterable @change="querySqlByTableName">
        <el-option v-for="(item, id) in businessModelList" :key="id" :value="item.tableName" :label="item.tableDesc"> </el-option>
      </el-select>
    </el-form-item>
    <sqlConfig :standardForm="standardForm" :sqlField="sqlField" :orderExprField="orderExprField" :index="index"></sqlConfig>
  </div>
</template>

<script>
import { querySqlByTableName } from "@/CommonDP/service/listFlow-service";
import sqlConfig from "./sqlConfig";
export default {
  components: { sqlConfig },
  props: {
    majorList: {
      type: Array,
      default() {
        return [];
      }
    },
    standardForm: {
      type: Object,
      default() {
        return {};
      }
    },
    businessModelListField: {
      type: String,
      default: "businessModelList"
    },
    tableNameField: {
      type: String,
      default: "tableName"
    },
    sqlField: {
      type: String,
      default: "sql"
    },
    orderExprField: {
      type: String,
      default: "orderExpr"
    },
    index: {
      type: [Number, null],
      default: null
    }
  },

  data() {
    return {
      count: 1
    };
  },

  computed: {
    businessModelList() {
      return this.majorList.filter((item) => this.standardForm[this.businessModelListField].indexOf(item.tableName) !== -1);
    }
  },

  methods: {
    async querySqlByTableName() {
      if (this.standardForm[this.tableNameField]) {
        const res = await querySqlByTableName(this.standardForm[this.tableNameField]);
        const { querySql, sortExpr } = res.data;
        this.standardForm[this.sqlField] = querySql;
        this.standardForm[this.orderExprField] = sortExpr;
      } else {
        this.standardForm[this.sqlField] = "";
      }
    },
    // 第一次会进行校验，忽略第一次
    check(rule, value, callback) {
      console.log(value);
      if (!value?.length && this.count === 1 && this.index !== null) {
        callback();
      } else if (!value?.length) {
        callback(new Error("请选择业务模型"));
      } else {
        callback();
      }
      this.count++;
    },
    resetCount() {
      this.count = 1;
    }
  }
};
</script>
